// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.marker-cluster-small {
  background-color: #49afa5 !important;
}

.leaflet-tooltip {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: none;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
}

.leaflet-tooltip-large {
  font-size: 14px;
}

.leaflet-tooltip-small {
  font-size: 11px;
}

.leaflet-tooltip-50F0E6 {
  border: #50f0e6;
  background-color: #50f0e6;
}

.leaflet-tooltip-00AA00 {
  border: #00aa00;
  background-color: #00aa00;
}

.leaflet-tooltip-FFAA00 {
  border: #ffaa00;
  background-color: #ffaa00;
}

.leaflet-tooltip-FF5500 {
  border: #ff5500;
  background-color: #ff5500;
}

.leaflet-tooltip-B41E1E {
  color: white;
  border: #b41e1e;
  background-color: #b41e1e;
}

.leaflet-tooltip-DAED07 {
  border: #daed07;
  background-color: #daed07;
}

.leaflet-tooltip-00C8FF {
  border: #00c8ff;
  background-color: #00c8ff;
}

.leaflet-tooltip-50CCAA {
  border: #50ccaa;
  background-color: #50ccaa;
}

.leaflet-tooltip-F0E641 {
  border: #f0e641;
  background-color: #f0e641;
}

.leaflet-tooltip-FF5050 {
  border: #ff5050;
  background-color: #ff5050;
}

.leaflet-tooltip-960032 {
  color: white;
  border: #960032;
  background-color: #960032;
}

.leaflet-tooltip-7D2181 {
  color: white;
  border: #7d2181;
  background-color: #7d2181;
}

.leaflet-tooltip-7C7B94 {
  color: white;
  border: #7c7b94;
  background-color: #7c7b94;
}
.leaflet-tooltip-05DBEB {
  border: #05dbeb;
  background-color: #05dbeb;
}

.leaflet-tooltip-00E400 {
  border: #00e400;
  background-color: #00e400;
}

.leaflet-tooltip-00FBFF {
  border: #00fbff;
  background-color: #00fbff;
}
.leaflet-tooltip-0A05A1 {
  border: #0a05a1;
  background-color: #0a05a1;
}

.leaflet-tooltip-00FF51 {
  border: #00ff51;
  background-color: #00ff51;
}
.leaflet-tooltip-2AA305 {
  border: #2aa305;
  background-color: #2aa305;
}

.leaflet-tooltip-EDC707 {
  border: #edc707;
  background-color: #edc707;
}
.leaflet-tooltip-ED8D07 {
  border: #ed8d07;
  background-color: #ed8d07;
}
.leaflet-tooltip-ED3D07 {
  border: #ed3d07;
  background-color: #ed3d07;
}

.leaflet-tooltip-960803 {
  color: white;
  border: #960803;
  background-color: #960803;
}

.leaflet-tooltip-05B5EB {
  border: #05b5eb;
  background-color: #05b5eb;
}

.leaflet-tooltip-0568EB {
  border: #0568eb;
  background-color: #0568eb;
}

.leaflet-tooltip-0542EB {
  color: white;
  border: #0542eb;
  background-color: #0542eb;
}

.leaflet-tooltip-060CBD {
  color: white;
  border: #060cbd;
  background-color: #060cbd;
}

.leaflet-tooltip-706E99 {
  color: white;
  border: #706e99;
  background-color: #706e99;
}

.leaflet-tooltip-5C5A9C {
  border: #5c5a9c;
  background-color: #5c5a9c;
}

.leaflet-tooltip-46439C {
  border: #46439c;
  background-color: #46439c;
}

.leaflet-tooltip-2B279C {
  border: #2b279c;
  background-color: #2b279c;
}

.leaflet-tooltip-461C9E {
  border: #461c9e;
  background-color: #461c9e;
}

.leaflet-tooltip-00FFA2 {
  border: #00ffa2;
  background-color: #00ffa2;
}

.leaflet-tooltip-7E0023 {
  color: white;
  border: #7e0023;
  background-color: #7e0023;
}

.leaflet-tooltip-FF0000 {
  border: #ff0000;
  background-color: #ff0000;
}

.leaflet-tooltip-FF7E00 {
  border: #ff7e00;
  background-color: #ff7e00;
}

.leaflet-tooltip-00E400 {
  border: #00e400;
  background-color: #00e400;
}

.leaflet-tooltip-FFFF00 {
  border: #ffff00;
  background-color: #ffff00;
}

.leaflet-tooltip-8F3F97 {
  color: white;
  border: #8f3f97;
  background-color: #8f3f97;
}
`, "",{"version":3,"sources":["webpack://./src/components/MainMap/MainMap.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,2CAA2C;EAC3C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B","sourcesContent":[".marker-cluster-small {\n  background-color: #49afa5 !important;\n}\n\n.leaflet-tooltip {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  border: none;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.leaflet-tooltip-large {\n  font-size: 14px;\n}\n\n.leaflet-tooltip-small {\n  font-size: 11px;\n}\n\n.leaflet-tooltip-50F0E6 {\n  border: #50f0e6;\n  background-color: #50f0e6;\n}\n\n.leaflet-tooltip-00AA00 {\n  border: #00aa00;\n  background-color: #00aa00;\n}\n\n.leaflet-tooltip-FFAA00 {\n  border: #ffaa00;\n  background-color: #ffaa00;\n}\n\n.leaflet-tooltip-FF5500 {\n  border: #ff5500;\n  background-color: #ff5500;\n}\n\n.leaflet-tooltip-B41E1E {\n  color: white;\n  border: #b41e1e;\n  background-color: #b41e1e;\n}\n\n.leaflet-tooltip-DAED07 {\n  border: #daed07;\n  background-color: #daed07;\n}\n\n.leaflet-tooltip-00C8FF {\n  border: #00c8ff;\n  background-color: #00c8ff;\n}\n\n.leaflet-tooltip-50CCAA {\n  border: #50ccaa;\n  background-color: #50ccaa;\n}\n\n.leaflet-tooltip-F0E641 {\n  border: #f0e641;\n  background-color: #f0e641;\n}\n\n.leaflet-tooltip-FF5050 {\n  border: #ff5050;\n  background-color: #ff5050;\n}\n\n.leaflet-tooltip-960032 {\n  color: white;\n  border: #960032;\n  background-color: #960032;\n}\n\n.leaflet-tooltip-7D2181 {\n  color: white;\n  border: #7d2181;\n  background-color: #7d2181;\n}\n\n.leaflet-tooltip-7C7B94 {\n  color: white;\n  border: #7c7b94;\n  background-color: #7c7b94;\n}\n.leaflet-tooltip-05DBEB {\n  border: #05dbeb;\n  background-color: #05dbeb;\n}\n\n.leaflet-tooltip-00E400 {\n  border: #00e400;\n  background-color: #00e400;\n}\n\n.leaflet-tooltip-00FBFF {\n  border: #00fbff;\n  background-color: #00fbff;\n}\n.leaflet-tooltip-0A05A1 {\n  border: #0a05a1;\n  background-color: #0a05a1;\n}\n\n.leaflet-tooltip-00FF51 {\n  border: #00ff51;\n  background-color: #00ff51;\n}\n.leaflet-tooltip-2AA305 {\n  border: #2aa305;\n  background-color: #2aa305;\n}\n\n.leaflet-tooltip-EDC707 {\n  border: #edc707;\n  background-color: #edc707;\n}\n.leaflet-tooltip-ED8D07 {\n  border: #ed8d07;\n  background-color: #ed8d07;\n}\n.leaflet-tooltip-ED3D07 {\n  border: #ed3d07;\n  background-color: #ed3d07;\n}\n\n.leaflet-tooltip-960803 {\n  color: white;\n  border: #960803;\n  background-color: #960803;\n}\n\n.leaflet-tooltip-05B5EB {\n  border: #05b5eb;\n  background-color: #05b5eb;\n}\n\n.leaflet-tooltip-0568EB {\n  border: #0568eb;\n  background-color: #0568eb;\n}\n\n.leaflet-tooltip-0542EB {\n  color: white;\n  border: #0542eb;\n  background-color: #0542eb;\n}\n\n.leaflet-tooltip-060CBD {\n  color: white;\n  border: #060cbd;\n  background-color: #060cbd;\n}\n\n.leaflet-tooltip-706E99 {\n  color: white;\n  border: #706e99;\n  background-color: #706e99;\n}\n\n.leaflet-tooltip-5C5A9C {\n  border: #5c5a9c;\n  background-color: #5c5a9c;\n}\n\n.leaflet-tooltip-46439C {\n  border: #46439c;\n  background-color: #46439c;\n}\n\n.leaflet-tooltip-2B279C {\n  border: #2b279c;\n  background-color: #2b279c;\n}\n\n.leaflet-tooltip-461C9E {\n  border: #461c9e;\n  background-color: #461c9e;\n}\n\n.leaflet-tooltip-00FFA2 {\n  border: #00ffa2;\n  background-color: #00ffa2;\n}\n\n.leaflet-tooltip-7E0023 {\n  color: white;\n  border: #7e0023;\n  background-color: #7e0023;\n}\n\n.leaflet-tooltip-FF0000 {\n  border: #ff0000;\n  background-color: #ff0000;\n}\n\n.leaflet-tooltip-FF7E00 {\n  border: #ff7e00;\n  background-color: #ff7e00;\n}\n\n.leaflet-tooltip-00E400 {\n  border: #00e400;\n  background-color: #00e400;\n}\n\n.leaflet-tooltip-FFFF00 {\n  border: #ffff00;\n  background-color: #ffff00;\n}\n\n.leaflet-tooltip-8F3F97 {\n  color: white;\n  border: #8f3f97;\n  background-color: #8f3f97;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
